import { connect } from 'react-redux'
import { AuthRedirect } from 'components'
import { actions } from 'appRedux/modules/Favorite'
import { actions as actionsModal } from 'appRedux/modules/Modal'
import { actions as actionsStock } from 'appRedux/modules/Stock'
import { StockSelector as component } from './StockSelector'


const mapStateToProps = (state, ownProps) => {
	const { current_group, favs } = state.Favorite;
	const fav = (favs.length > 0) ? favs[current_group].stocks : [];

	return {
		current_group: current_group,
		fav: fav,
		is_fav: fav.filter((item) => (
			item.stock_code === ownProps.stock.stock_code
		)).length !== 0,
		is_mobile: state.Layout.is_mobile,
	}
};
const mapDispatchToProps = (dispatch, ownProps) => ({
	onFavGroupStockerAdd: (stock) => dispatch(
		actions.addFavGroupStockRequest(stock)
	),
	onFavGroupStockDelete: (stockCode) => dispatch(
		actions.deleteFavGroupStockRequest(stockCode)
	),
	onModalOpen: (id) => dispatch(actionsModal.toggleModal(id, true)),
	onStockSet: (stock) => dispatch(actionsStock.setStock(stock)),
	onStockRecordRequest: (stockCode) => dispatch(
		actionsStock.recordStockRequest(stockCode)
	),
});
const StockSelector = AuthRedirect.AuthProps(connect(mapStateToProps, mapDispatchToProps)(component));


export { StockSelector } 
